import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CsAgentAuthService } from '@spartacus/asm/root';
import { BaseSiteService, GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { ICON_TYPE } from '@spartacus/storefront';
import { UserAccountFacade } from '@spartacus/user/account/root';
import jsPDF from 'jspdf';
import * as moment from 'moment';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { FaxEmailPopupComponent } from 'src/app/shared/modules/fax-email-popup/fax-email-popup/fax-email-popup.component';
import { LoactionStripService } from 'src/app/shared/modules/location-strip/loaction-strip.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { CommonUtils } from '../../../shared/utils/common.utils';
import { OrderHistoryService } from '../../order-history.service';

@Component({
  selector: 'app-latest-orders',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './latest-orders.component.html',
  styleUrls: ['./latest-orders.component.scss']
})
export class LatestOrdersComponent implements OnInit {

  //ASM -eorders related
  isAsmUser: boolean = false;
  invoicesListForMailASm: any = [];
  checkboxesList = []
  faxEmailCloseSub: Subscription;
  csAgentAuthSubscription: Subscription;

  @ViewChild('latestOrdersTable') latestOrderTable: ElementRef;
  ordersList = [];
  totalOrders: number = 0;
  orders = [];
  userId;
  pageLength = '18 per page';
  timeFrameList = ['Select', '30 Days', '3 Months', '6 Months', '1 Year'];
  pageList = [this.pageLength, '36 per page', '72 per page', 'All'];
  timeFrame = 'Select';
  fromDate: any;
  toDate: any;
  poNumber: any;
  order: any;
  invoice: any;
  dateError = false;
  selectedTimeFrame = 'Select';
  pageSizeperPage = this.pageLength;
  pageSize = 18;
  curPage = 1;
  end: number;
  @ViewChild('facetsRwd', { static: false }) private readonly facetsRwd;
  singleDateError = false;
  facetsList: any = [{ type: 'timeFrame', value: '3 Months' }];
  filters = {
    fields: 'DEFAULT',
    currentPage: this.curPage - 1,
    pageSize: this.pageSize,
  };
  maxSelectionDate = moment(new Date()).endOf('day').toDate();
  minSelectionDate = moment({ year: 2024, month: 5, day: 3 }).startOf('day').toDate();
  dateFormat = 'MM/DD/YYYY';
  userDataSubscription: any;
  userInfo: any;
  FilteredData: any;
  allOrdersSubscription: any;
  xlsDownloaded: boolean = false;
  orderStatusList = ['All', 'Open', 'Partially Shipped', 'Shipped'];
  orderStatusSub: Subscription;
  orderStatus = 'All'
  isFilterSelected = false;
  product: any;
  dataFrom: any;
  baseSiteId: string;
  orderNumStart: number = 0;
  orderNumEnd: number;
  orderFullResults: any;
  startCount: number;
  additionalRowAdded: boolean;
  LocationListSub: Subscription;
  isLocationSelected: boolean;
  selectedLocations: any;
  locationFilter: {};
  firewallExempt: boolean = false;
  isComServeAgent: boolean = false;
  showProgress: boolean = true;

  constructor(
    private readonly service: OrderHistoryService,
    private readonly user: UserAccountFacade,
    private readonly cd: ChangeDetectorRef,
    private readonly modalService: NgbModal,
    private readonly localeService: BsLocaleService,
    private readonly orderHistoryService: OrderHistoryService,
    private readonly csAgentAuthService: CsAgentAuthService,
    private readonly baseSiteService: BaseSiteService,
    private readonly globalMessage: GlobalMessageService,
    private readonly locStripService: LoactionStripService,
    private readonly sharedService: SharedService
  ) {
    enGbLocale.weekdaysShort = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    enGbLocale.week.dow = 0;
    defineLocale('en-gb', enGbLocale);
    this.localeService.use('en-gb');
  }

  ngOnInit() {
    this.orderNumEnd = this.pageSize;
    //asm user check added
    this.csAgentAuthSubscription = this.csAgentAuthService.isCustomerEmulated().subscribe((res) => {
      this.isAsmUser = res ? res : false;
    });
    this.baseSiteService.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);
    this.LocationListSub = this.locStripService.emitSelectedLocs.subscribe(locsData => {
      this.isLocationSelected = !!locsData?.length;
      this.selectedLocations = locsData;
    });
  
    this.end = this.pageSize;
    this.getOrderList();
    this.orderHistoryService.getOrderStatus({
      enumerationType: 'OrderStatus',
      fields: 'DEFAULT',
    });
  }

  preserveTabState() {
    this.orderHistoryService.tabId = 0;
    localStorage.setItem('historicalTab', 'false');

  }

  refine(): void {
    this.modalService.open(this.facetsRwd, {
      windowClass: this.baseSiteId
    });
  }

  hide(): void {
    this.modalService.dismissAll(this.facetsRwd);
  }

  generateInvoicePDF(invoiceNo) {
    this.service.downloadPdf(invoiceNo);
  }

  getOrderList(page?) {
    this.userInfo = this.user.get().subscribe((userData) => {
      this.userId = userData;
      if (userData) {
        this.applyFilter(page);
      }
    });
  }

  ngOnDestroy() {
    this.userDataSubscription?.unsubscribe();
    this.userInfo?.unsubscribe();
    this.allOrdersSubscription?.unsubscribe();
    this.csAgentAuthSubscription?.unsubscribe();
    this.faxEmailCloseSub?.unsubscribe();
  }

  formatOrders() {
    this.orders = [];
    if (this.ordersList) {
      this.ordersList.forEach((element) => {
        const uniquePackingSlips = element?.packingSlips?.length > 0 ? [...new Set(element?.packingSlips)] : '';
        const uniqueTrackingNumbers = element?.tracking?.length > 0 ? [... new Set(element?.tracking)] : '';
        const data = {
          code: element.code,
          guid: element.guid,
          invoices: element.invoices,
          sapSystemType:
            element && element.orderType ? element.orderType : '',
          placed: element.createdOn,
          placedDate: element.createdOn,
          purchaseOrderNumber: element.purchaseOrderNumber,
          shipToId: element.shipToId,
          shipToName: element.shipToName,
          status: element.status,
          statusDisplay: element.statusDisplay,
          total: element.total,
          tracking: uniqueTrackingNumbers,
          packingSlips: uniquePackingSlips
        };
        this.orders.push(data);
      });
    }

    //
  }

  changePageSize() {
    this.curPage = 1;
    if (this.pageSizeperPage === this.pageLength) {
      this.pageSize = 18;
      this.orderNumEnd = this.pageSize;
    }
    if (this.pageSizeperPage === '36 per page') {
      this.pageSize = 36;
      this.orderNumEnd = this.pageSize;
    }
    if (this.pageSizeperPage === '72 per page') {
      this.pageSize = 72;
      this.orderNumEnd = this.pageSize;
    }
    if (this.pageSizeperPage === 'All') {
      this.pageSize = this.totalOrders;
      this.orderNumEnd = this.pageSize;
    }
    if (this.pageSize < this.totalOrders) {
      this.end = this.pageSize;
    } else {
      this.end = this.totalOrders;
    }
  }

  getCurrentPage(type) {
    this.curPage = type === 'prev' ? this.curPage - 1 : this.curPage + 1;
    this.filters.currentPage = this.curPage - 1;
    this.pagination();
    this.cd.detectChanges();
  }

  numberOfPages() {
    if (this.ordersList && this.totalOrders && this.pageSize > 0) {
      return Math.ceil(this.totalOrders / this.pageSize);
    } else {
      return 1;
    }
  }

  iconTypes = ICON_TYPE;

  sortColumn(event, fieldName, dataList, type): any {
    CommonUtils.onSortClick(event, fieldName, dataList, type); // Column Sorting
  }

  removeFacet(filter) {
    this.facetsList.forEach((element, index) => {
      if (element === filter) {
        this.facetsList.splice(index, 1);
        if (filter.type === 'date') {
          this.fromDate = undefined;
          this.toDate = undefined;
          this.timeFrame = 'Select';
        }
        if (filter.type === 'poNumber') {
          this.poNumber = undefined;
        }
        if (filter.type === 'orderNumber') {
          this.order = undefined;
        }
        if (filter.type === 'invoiceNumber') {
          this.invoice = undefined;
        }
        if (filter.type === 'timeFrame') {
          this.timeFrame = 'Select';
          this.selectedTimeFrame = 'ALL';
        }
        if (filter.type === 'productName') {
          this.product = undefined;
        }
        if (filter.type === 'statuses') {
          this.orderStatus = 'All';
        }
        this.curPage = 1;
        this.getOrderList();
        this.cd.detectChanges();
      }
    });
  }

  pagination() {
    this.orderNumStart = ((this.curPage - 1) * this.pageSize) + 1;
    this.orderNumEnd = this.curPage * this.pageSize < this.totalOrders ? this.curPage * this.pageSize : this.totalOrders;
  }

  applyFilter(type?: string) {
    this.orderHistoryService.tabId = 0;
    if (this.fromDate && this.toDate) {
      if (this.fromDate.getTime() > this.toDate.getTime()) {
        this.dateError = true;
        return false;
      } else {
        this.dateError = false;
      }
    }
    const params = { userId: this.userId.uid };
    this.filters = this.getfilterQuery();
    this.showFacets(JSON.stringify(this.filters));
    if (type !== 'page') {
      this.filters.currentPage = 0;
      this.curPage = 1;
      this.invoicesListForMailASm = [];
    }
    this.orderHistoryService.tabFilters = this.filters;
    this.ordersList = []; //clearing before api call/assignment.
    this.service.getOrderHistory(params, this.filters);
    this.userDataSubscription = this.service.userData$.subscribe((res) => {
      if (res !== null) {
        this.orderNumStart = (res?.orders.length > 0) ? 1 : 0;
        this.orderFullResults = res;
        this.ordersList = res?.orders;
        this.showProgress = false;
        this.totalOrders = res?.pagination?.totalResults;
        if (res?.isComServeAgent) {
          this.isComServeAgent = res.isComServeAgent;
        }
        this.cd.detectChanges();
        this.formatOrders();
        if (this.curPage > 1) {
          this.startCount = this.pageSize * this.filters.currentPage;
        }
        if (this.curPage == 1) {
          this.startCount = 1;
        }
        if (this.ordersList.length == 0) {
          this.startCount = 0;
        }
        if (this.pageSize > this.totalOrders) {
          this.end = this.totalOrders;
        } else {
          if (this.pageSize < this.totalOrders) {
            this.end = this.pageSize * this.curPage;
            if (this.end > this.totalOrders) {
              this.end = this.totalOrders;
            }
          }
        }

        this.ordersList = CommonUtils.sortArr(
          'placed',
          this.orders,
          'Date',
          -1
        );
        this.cd.detectChanges();
        this.selectedTimeFrame = this.timeFrame == 'Select' ? 'ALL' : this.timeFrame;
        if (type === 'mobile') {
          this.hide();
        }
      }
    });
    window.scrollTo(0, 0);
    return true;
  }

  showFacets(data) {
    const facets = JSON.parse(data);
    delete facets.fields;
    delete facets.currentPage;
    delete facets.pageSize;
    if (facets.fromDate && facets.toDate) {
      facets.date = `${moment(this.fromDate).format(
        this.dateFormat
      )} - ${moment(this.toDate).format(this.dateFormat)}`;
      this.dataFrom = 'from' + ' ' + facets.date;
      delete facets.fromDate;
      delete facets.toDate;
    }
    if (facets.facetTimeFrame != 'ALL') {
      if (facets.facetTimeFrame != undefined && facets.facetTimeFrame != 'Select') {
        facets.facetTimeFrame = this.timeFrame;
      } else {
        delete facets.facetTimeFrame;
      }
    } else if (facets.facetTimeFrame != 'ALL') {
      delete facets.facetTimeFrame;
    }
    if (facets.timeFrame) {
      delete facets.timeFrame;
    }
    if (facets.productCode) {
      facets.productName = this.product.name;
      delete facets.productCode;
    }
    if (facets.statuses == 'All') {
      delete facets.statuses;
    }
    if (facets.selectedLocations) {
      delete facets.selectedLocations;
    }
    this.facetsList = Object.entries(facets).map(([type, value]) => ({
      type,
      value,
    }));
  }

  getfilterQuery() {
    const data: any = {
      fields: 'DEFAULT',
      currentPage: this.curPage - 1,
      pageSize: this.pageSize,
    };
    if (this.invoice) {
      data.invoiceNumber = this.invoice;
    }
    if (this.order) {
      data.orderNumber = this.order;
    }
    if (this.poNumber) {
      data.poNumber = this.poNumber;
    }
    if (this.timeFrame && !this.fromDate && !this.toDate) {
      if (this.timeFrame === '30 Days') {
        data.timeFrame = '30';
        data.facetTimeFrame = '30 days';
      }
      if (this.timeFrame === '3 Months') {
        data.timeFrame = '3';
        data.facetTimeFrame = '3 months'
      }
      if (this.timeFrame === '6 Months') {
        data.timeFrame = '6';
        data.facetTimeFrame = '6 months'
      }
      if (this.timeFrame === '1 Year') {
        data.timeFrame = '1';
        data.facetTimeFrame = '1 year'
      }
    }
    if (this.fromDate && this.toDate) {
      if (this.timeFrame === 'Select' && data.timeFrame) {
        delete data.timeFrame;
      }
      data.fromDate = moment(this.fromDate).format('DD-MM-YYYY');
      data.toDate = moment(this.toDate).format('DD-MM-YYYY');
    }
    if (this.product) {
      this.orderHistoryService.product = this.product;
      data.productCode = this.product.code;
    }
    if (this.orderStatus) {
      data.statuses = this.orderStatus;
    }
    if (this.isLocationSelected) {
      if (this.selectedLocations.length > 1) {
        data.selectedLocations = '';
      }
      this.selectedLocations.forEach((loc) => {
        if (this.selectedLocations.length > 1) {
          data.selectedLocations = (data.selectedLocations === '') ? loc.accountNumber : data.selectedLocations + ',' + loc.accountNumber;
        }
        else {
          data.selectedLocations = loc.accountNumber;
        }
      })

    }

    return data;
  }

  validateDate() {
    this.timeFrame = this.fromDate || this.toDate ? 'Select' : this.timeFrame;
    if (this.fromDate && this.toDate) {
      this.singleDateError = false;
      if (this.fromDate.getTime() > this.toDate.getTime()) {
        this.dateError = true;
      } else {
        this.dateError = false;
      }
      this.isFilterSelected = true;
    } else {
      this.isFilterSelected = false;
    }
  }

  clearDateRange() {
    this.fromDate = undefined;
    this.toDate = undefined;
    this.isFilterSelected = true;
  }

  generateSavePdf() {
    this.cd.detectChanges();
    const additionalRowDiv = document.createElement('div');
    additionalRowDiv.innerText = 'Order History';
    additionalRowDiv.style.marginBottom = '20px';
    additionalRowDiv.style.marginTop = '27px';
    additionalRowDiv.style.fontSize = '18px';
    additionalRowDiv.style.fontWeight = 'bold';
    const contentElement = document.getElementById('latestOrdersTable');
    contentElement.insertBefore(additionalRowDiv, contentElement.firstChild);
    // this.additionalRowAdded = true;

    const element = (document.getElementById('latestOrdersTable')) as HTMLElement;
    let doc = new jsPDF('p', 'pt', 'letter');
    doc.html(element, {
      callback: function (jsPdf) {
        jsPdf.save("Order History.pdf");
      },
      margin: [20, 20, 20, 40], // Set appropriate margins
      autoPaging: 'text', // Crucial for handling text flow across pages
      html2canvas: {
        allowTaint: true,
        letterRendering: true,
        logging: false,
        scale: 0.5, // Adjust the scale to fit content
      },

    });
  }

  generateXls(allOrders) {
    const list = JSON.parse(JSON.stringify(allOrders));
    const orders = [];
    list.forEach((element) => {
      const dateOnly = element.placed.split('T');
      const invoices = (element?.invoices?.length > 0) ? Array.prototype.map
        .call(element?.invoices, function (item) {
          return item?.invoiceNumber;
        })
        .join(',') : '';
      const uniquePackingSlips = element?.packingSlips?.length > 0 ? [...new Set(element?.packingSlips.map(data => data.slice(0, -6)))].join(',') : '';
      const uniqueTrackingNumbers = element?.tracking?.length > 0 ? (element.tracking.filter((value, index, self) => index === self.findIndex((t) => (t.code === value.code && t.name === value.name))).map(data => data.trackingNumber)).join(',') : '';
      orders.push({
        Date: moment(dateOnly[0]).format(this.dateFormat),
        Type: element.orderType,
        'Order #': element.code,
        Status: element.statusDisplay,
        'PO #': element.purchaseOrderNumber,
        'Invoice #': invoices,
        'Packing slip*': uniquePackingSlips,
        'Tracking #': uniqueTrackingNumbers,
      });
    });
    this.service.downloadXls(orders, 'Recent Orders');
    this.xlsDownloaded = true;
  }

  async generateSaveXls() {
    let xlsDownloadFilter: any = JSON.stringify(this.filters);
    this.xlsDownloaded = false;
    xlsDownloadFilter = JSON.parse(xlsDownloadFilter);
    xlsDownloadFilter.currentPage = 0;
    xlsDownloadFilter.pageSize = 1000;
    const params = { userId: this.userId.uid };
    this.service.getAllOrders(params, xlsDownloadFilter);
    this.allOrdersSubscription = this.service.allOrders$.subscribe((res) => {
      if (res !== null) {
        if (!this.xlsDownloaded) {
          this.generateXls(res?.orders);
          this.cd.detectChanges();
          this.service.allOrders?.next(null);
        }
      }
    });
  }

  clearFilters(type?) {
    this.facetsList = [];
    this.filters = {
      fields: 'DEFAULT',
      currentPage: 0,
      pageSize: this.pageSize,
    };
    this.curPage = 1;
    this.invoice = undefined;
    this.fromDate = undefined;
    this.toDate = undefined;
    this.order = undefined;
    this.invoice = undefined;
    this.poNumber = undefined;
    this.timeFrame = 'Select';
    this.isFilterSelected = false;
    this.product = undefined;
    this.orderStatus = 'All';
    this.selectedTimeFrame = 'ALL';
    this.dateError = false;
    this.getOrderList();
    if (type == 'mobile') {
      this.hide()
    }
    this.cd.detectChanges();
  }

  onKeyPress(value: any) {
    if (value) {
      this.isFilterSelected = true;
    } else {
      this.isFilterSelected = false;
    }
  }

  getSelectedProduct(params) {
    if (params) this.isFilterSelected = true;
    this.product = params;
  }

  captureInvoiceForMail(event: Event, invoiceNo: string, index: number) {
    const checkbox = event.target as HTMLInputElement;
    const isChecked = checkbox.checked;
    let invoice = index + '_checkbox_' + invoiceNo;
    if (isChecked) {
      this.invoicesListForMailASm?.push(invoice);
    }
    else {
      this.invoicesListForMailASm = this.invoicesListForMailASm.filter(item => item !== invoice);
    }
  }
  openFaxEmailPopup() {
    const modalRef = this.modalService.open(FaxEmailPopupComponent, {
      centered: true,
      backdrop: 'static',
      windowClass: `faxemailSendModal ${this.baseSiteId}`
    });
    let invoicesCount = this.invoicesListForMailASm?.length;
    modalRef.componentInstance.noOfInvoices = invoicesCount;
    modalRef.componentInstance.invoicesList = this.invoicesListForMailASm;
    modalRef.componentInstance.userId = this.userId.uid;
    modalRef.componentInstance.reqType = 'ro';
    this.faxEmailCloseSub = modalRef.componentInstance.popupCloseEvent.subscribe((res) => {
      if (res === 'closed') {
        this.invoicesListForMailASm = [];
        this.cd.detectChanges();
        this.faxEmailCloseSub?.unsubscribe();
      }
    });
  }

  getCheckBoxStatus(index, invoiceNo) {
    let id = index + '_checkbox_' + invoiceNo;
    if (this.invoicesListForMailASm?.includes(id)) {
      return true;
    }
    else {
      return false;
    }
  }

  downloadPackingSlipPdf(packingSlip) {
    let params = {
      "invoiceNumber": packingSlip,
      "documentType": "LIKP"
    }
    this.orderHistoryService.getFile(params).subscribe((res) => {
      const file = new Blob([res], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL, '_blank');
    }, (err) => {
      window.scrollTo(0, 0);
      this.globalMessage.add('Requested document is not available at this moment', GlobalMessageType.MSG_TYPE_ERROR);
    })
  }

  goTovendorSite(trackingNumber, url) {
    url = url.replace("<TRACKN>", trackingNumber)
    window.open(url, '_blank');
  }
  asmStringCheck(invoiceNumber) {
    let val = (/^\d+$/).test(invoiceNumber);
    return (!val || invoiceNumber.length >= 11 || invoiceNumber.length <= 7
      || (this.isAsmUser && this.isComServeAgent));
  }
  convertToPlain(html) {
    var tempDivElement = document.createElement("div");
    tempDivElement.innerHTML = html;
    return tempDivElement.textContent || tempDivElement.innerText || "";
  }
}
